
import axios from "axios";


const url = "https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api";


export const login = (headers) => {
    return axios.get(`${url}/get_role`, {
        headers: headers
    });
};


export const getSiteData = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/get_sites`, { headers })
}

export const getStatesDropDown = (accessToken) => {
  console.log("accessToken =", accessToken);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  return axios.get(`${url}/states`, { headers });
};


export const getStatesUploadPermissionDropDown = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/upload_states`, { headers })
}

export const getPermissionStatesDropDown = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/permissions/states`, { headers })
}

export const getLocationDropDown = ({ state_id }, accessToken) => {
console.log("LOCATION TOKEN =", accessToken);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  console.log("headers =", headers);

  return axios.get(`${url}/locations/${state_id}`, {
    headers,
  });
};

export const getLocationUploadPermissionDropDown = ({ state_id },accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/upload_location/${state_id}`, { headers })
}

export const getPermissionLocationDropDown = ({ state_id }) => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/permissions/locations/${state_id}`, { headers })
}

export const getSiteDropDown = ({ location_id }, accessToken) => {
  console.log("SITE TOKEN =", accessToken);
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  return axios.get(`${url}/sites/${location_id}`, {
    headers,
    
  });
};

export const getSiteUploadPermissionDropDown = ({ location_id },accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/upload_site/${location_id}`, { headers })
}


export const getPermissionSiteDropDown = ({ location_id }) => {
  console.log("location_id =", location_id);
  console.log("API URL =", `${url}/permissions/sites/${location_id}`);

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  console.log("Headers =", headers);

  return axios.get(`${url}/permissions/sites/${location_id}`, {
    headers,
  });
};;
export const getPermissionDocumentCategory = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/permissions/document-categories`, { headers })
}
export const getUploadPermissionDocumentCategory = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/upload_category`, { headers })
}

export const getUploadAllDocumentCategory = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/document-categories_all`, { headers })
}
export const getCaseTypes = (siteId) => {
  const headers = {
    'Content-Type': 'application/json'
  };

  return axios.get(`${url}/case_types/${siteId}`, {
    headers
  });
};



export const getSiteTypeDropDown  = () => {
  const headers = {
    'Content-Type': 'application/json',
    
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/site_type`, { headers})
}





export const createNewSite = (data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`

  };
  return axios.post(`${url}/new_site`, JSON.stringify(data), { headers })

}

export const reportLog = (document_id,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`

  };
  return axios.get(`${url}/report_log?document_id=${document_id}`, { headers })

}
export const courseHistoryTrack = (os_number,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`

  };
  return axios.get(`${url}/case_logs?os_number=${os_number}`, { headers })

}



export const getUsersName = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`

  };
  return axios.get(`${url}/get_users`, { headers })

}



export const getSurvey = (siteId,accessToken) => {
  const link = `https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/get_survey?site_id=${siteId}`;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
  return axios.get(link, { headers });

 
};








export const getCourtStage = async () => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  try {
    const response = await axios.get(`${url}/court_stage`, {
      headers,
     
    });

    console.log("Court Stage response.data:", response.data);

    return response;
  } catch (error) {
    console.error("Error fetching court stages:", error);
    throw error;
  }
};







export const getCourtCases = (siteId,accessToken) => {
  const link = `https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/get_cases?site_id=${siteId}`;
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(link, { headers });
};


export const createNewSurvey = (data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`

  };
  return axios.post(`${url}/new_survey`, JSON.stringify(data), { headers })

}

export const createNewCase = (data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`

  };
  return axios.post(`${url}/new_case`, JSON.stringify(data), { headers })

}

export const getUniqueNo = ({ site_id }) => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/unique_servey_no/${site_id}`, { headers })
}


export const editSiteSummry = (site_id, description,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/site/${site_id}/description`,
    { description }, // Send description as the body
    { headers }
  );
};

export const editCourtCase = (os_number, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/update_case/${os_number}`,
    data,           // ✅ Proper request body
    { headers }     // ✅ Separate headers
  );
};

export const editSurvey = (unique_survey_no, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/update_survey/${unique_survey_no}`,
    data,           // ✅ Proper request body
    { headers }     // ✅ Separate headers
  );
};



export const getDocumentCatgory = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/document-categories`, { headers })
}

export const getBuildingCode = (site_id) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(`${url}/building_code/${site_id}`, { headers })
}
export const getBuilding = (siteId,accessToken) => {
  const link = `https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/get_building_code?site_id=${siteId}`;
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(link, { headers });
};


export const getDocumentUploaded = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
    
  };
  return axios.get(`${url}/documents/latest`, { headers })
}

export const getDocumentType = ({ category_id, site_id }) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  return axios.get(
    `${url}/document-types/${category_id}?site_id=${site_id}`,
    {
      headers,
      
    }
  );
};

export const getAllDocumentType = ({ category_id }) => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/document-types_all/${category_id}`, { headers })
}

export const formUpload = (data,accessToken) => {
  return axios.post(`${url}/v2/upload`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
       Authorization: `Bearer ${accessToken}`
    }
  });
};
export const getCourtStatus = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/court_status`, { headers })
}

export const getOsNumber = (site_id) => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/os_number/${site_id}`, { headers })
}

export const getEntity = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/entity`, { headers })
}

export const getDocuments = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/documents/access`, { headers })
}

export const getDocumentsRejected = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/documents/rejected`, { headers })
}

export const getDocumentsApproved = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/documents/approved`, { headers })
}

export const getDocumentsPending = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/documents/pending`, { headers })

}

export const approvedRejected = (approval_id, data, accessToken) => {
  return axios.post(`${url}/approvals/${approval_id}/decide`, data, {
    headers: {
      'Content-Type': 'application/json' ,
       Authorization: `Bearer ${accessToken}`// use JSON here since it's not form-data
    }
  });
};

export const addUser = (data,accessToken) => {
  return axios.post(`${url}/add_user`, data, {
    headers: {
      'Content-Type': 'application/json',
       Authorization: `Bearer ${accessToken}` // use JSON here since it's not form-data
    }
  });
};


export const getPermissions = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/get_permissions`, { headers })

}

export const getPermissionsFilter = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/users`, { headers })

}


export const getRoles = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/roles`, { headers })

}

export const getUsers = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  return axios.get(`${url}/all_users`, { headers })

}


export const getPdf = async (document_id,accessToken) => {
  const response = await axios.get(`https://land-documents-prod-bwh8gjewh3g7ejhf.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${document_id}`, {
    responseType: "arraybuffer",
     Authorization: `Bearer ${accessToken}`
  });

  const blob = new Blob([response.data], { type: "application/pdf" });
  const pdfUrl = URL.createObjectURL(blob);

  return { pdfUrl }; // <- wrap it in object so your existing logic works
};



export const addPermission = (data,accessToken) => {
  return axios.post(`${url}/permissions/grant`, data, {
    headers: {
      'Content-Type': 'application/json',
       Authorization: `Bearer ${accessToken}`
    }
  });
};

export const permissionDelete = (access_id,accessToken) => {
  return axios.delete(`${url}/permissions/${access_id}`, {
    headers: {
      'Content-Type': 'application/json',
       Authorization: `Bearer ${accessToken}`
    }
  });
};
export const permissionDeleteUsers = (user_id,accessToken) => {
  return axios.delete(`${url}/delete_user/${user_id}`, {
    headers: {
      'Content-Type': 'application/json',
       Authorization: `Bearer ${accessToken}`
    }
  });
};

export const reportApi = (data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.post(`${url}/report`, JSON.stringify(data), { headers })
}

export const editPermission = (access_id, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/permissions/${access_id}`,
    data,           // ✅ Proper request body
    { headers }     // ✅ Separate headers
  );
};

export const editUser = (user_id, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/update_user?user_id=${user_id}`,
    data,           // ✅ Proper request body
    { headers }     // ✅ Separate headers
  );
};

export const editBuilding = (building_code, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };

  return axios.put(
    `${url}/update_building_code/${building_code}`,
    data,           // ✅ Proper request body
    { headers }     // ✅ Separate headers
  );
};

export const reupload = (document_id, data,accessToken) => {
  return axios.put(
    `${url}/reupload/${document_id}`,
    data, // This must be an instance of FormData
    {
      headers: {
        'Content-Type': 'multipart/form-data',
         Authorization: `Bearer ${accessToken}`
      },
    }
  );
};




export const createBuilding = (site_id, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
   Authorization: `Bearer ${accessToken}`
  };

  return axios.post(
    `${url}/create_building/${site_id}`,
    data,         // Request body data
    { headers }   // Headers config
  );
};

export const createBorrowal = (document_id, data,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.post(
    `${url}/create_borrow/${document_id}`,
    data,         // Request body data
    { headers }   // Headers config
  );
};
export const returnBorrowal = (document_id,accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };

  return axios.post(
    `${url}/return/${document_id}`,       // Request body data
    { headers }   // Headers config
  );
};

export const getBorrowals = (accessToken) => {
  const headers = {
    'Content-Type': 'application/json',
     Authorization: `Bearer ${accessToken}`
  };
  return axios.get(`${url}/get_borrowals`, { headers })
}

export const fetchFoundationRoles = async () => {
  const res = await axios.get(`${url}/foundation_role`);
  return res.data; // return only the data array
};

export const getNotifications = async (accessToken) => {
  try {
    const res = await axios.get(`${url}/notifications`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, 
      },
      // withCredentials: true
    });
    return res.data || [];
  } catch (error) {
    console.error("Error fetching notifications:", error.response?.data || error.message);
    throw error;
  }
};

export const markNotificationRead = async (notification_id, accessToken) => {
  try {
    await axios.put(
      `${url}/notifications/${notification_id}/read`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        // withCredentials: true
      }
    );
  } catch (error) {
    console.error("Error marking notification as read:", error.response?.data || error.message);
    throw error;
  }
};

export const generateTranslation = (
  documentId,
  language,
  accessToken
) => {
  return axios.post(
    `${url}/documents/${documentId}/translation/generate`,
    {
      language,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};
export const decideTranslation = (
  documentId,
  data,
  accessToken
) => {
  return axios.post(
    `${url}/documents/${documentId}/translation/decide`,
    data,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getDocumentClassificationDropDown = () => {
  const headers = {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${accessToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return axios.get(`${url}/document-copy-type`, { headers });
};
export const getPropertyTaxApplicability = () => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  return axios.get(
    `${url}/property-tax-applicability`,
    { headers }
  );
};

export const getDocumentCategoriesByAccess = (
  { state_id, location_id, site_id },
  accessToken
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  let apiUrl =
    `${url}/document-categories-by-access?state_id=${state_id}`;

  if (location_id) {
    apiUrl += `&location_id=${location_id}`;
  }

  if (site_id) {
    apiUrl += `&site_id=${site_id}`;
  }

  return axios.get(apiUrl, {
    headers,
   
  });
};

export const getBorrowalUsers = (accessToken) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  return axios.get(`${url}/users?borrowal=true`, {
    headers,
   
  });
};


export const getTranslationStatus = (
  documentId,
  jobId,
  accessToken
) => {
  return axios.get(
    `${url}/documents/${documentId}/translation/generate/status`,
    {
      params: {
        job_id: jobId,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};




// ================= SUMMARY =================

export const generateSummary = (
  documentId,
  accessToken
) => {
  return axios.post(
    `${url}/documents/${documentId}/summary/generate`,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};


export const getSummaryStatus = (
  documentId,
  jobId,
  accessToken
) => {
  return axios.get(
    `${url}/documents/${documentId}/summary/generate/status`,
    {
      params: {
        job_id: jobId,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};


export const decideSummary = (
  documentId,
  data,
  accessToken
) => {
  return axios.post(
    `${url}/documents/${documentId}/summary/decide`,
    data,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};


export const getSummary = (
  documentId,
  accessToken
) => {
  return axios.get(
    `${url}/documents/${documentId}/summary`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};
// ======================files api
export const getTranslation = (
  documentId,
  accessToken
) => {
  return axios.get(
    `${url}/documents/${documentId}/translation`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// ===========================================
export const getCnrNumber = (site_id) => {
  return axios.get(`${url}/cnr_number/${site_id}`).then((response) => {
    console.log("CNR Number response.data:", response.data);
    return response;
  });
};

